<template>
    <v-card>
        <v-card-title class="justify-space-between">
            <v-row>
                <v-col cols="12" md="9" class="font-italic grey--text darken-3 text-uppercase ">
                    {{ $t('delivery') }}
                </v-col>
                <v-col cols="12" md="3" class="py-4 py-md-0">
                    <v-select
                        class="pt-0 mt-0"
                        v-model="orderData.statusID"
                        :label="statuses.label"
                        item-text="name"
                        item-value="id"
                        :items="statuses.items"
                        color="orange lighten-2"
                        item-color="orange lighten-2"
                        disabled
                    ></v-select>
                </v-col>
            </v-row>
        </v-card-title>
        <v-card-text class="pb-0">
            <v-row>
                <v-col cols="12" md="3">
                    <v-text-field
                        class="py-0 my-0"
                        :value="orderData.geo"
                        :label="$t('settlement')"
                        disabled
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                    <v-text-field
                        class="py-0 my-0"
                        v-model="orderData.address"
                        :label="$t('address')"
                        disabled
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                    <v-text-field
                        class="py-0 my-0"
                        v-model="orderData.deliveryDate"
                        :label="$t('arriveDate')"
                        disabled
                    ></v-text-field>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import OrderExtendInfo from "../../../mixins/OrderExtendInfo"

export default {
    name: "ExtendDeliveryInfo",
    mixins: [OrderExtendInfo],
    props:['statuses']
}
</script>
